export default "__VITE_ASSET__DKxKPSvu__"